const menu = document.querySelector('.menu__ul--depth-0');
const topbar = document.querySelector('.topbar__case');
const mainmenu = document.querySelector('.main-menu');

function moveMenu() {
    if (window.innerWidth <= 1024) {
        topbar.appendChild(menu);
    } else {
        mainmenu.appendChild(menu);
    }
}

window.addEventListener('resize', moveMenu);
window.addEventListener('load', moveMenu);
moveMenu()